<div class="tutorial-button">
    <div class="tutorial-button__icon" [style.background-image]="'url(' + tutorial.iconURL + ')'"></div>
    <div class="tutorial-button__title">{{ tutorial.title }}</div>
</div>
